module.exports = __webpack_public_path__ + "static/media/block1background.66ef3a2a.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/whereToBuy/block1background.png
// module id = 213
// module chunks = 0